export default __webpack_public_path__ + "static/media/bean_stew.6dd5d2ae.jpg";